export default "__VITE_ASSET__CH9waSE7__"